// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-auto{
	width: auto;
}
.dataTables_info{
	padding-top: 0.85rem;
}
.text-error{
	color: #dc3545;
	font-size: 0.8rem;
}
.error-fullname{
	margin-top: -10px;
}
/* #candidateList tr.odd td.dataTables_empty{
	display: none!important;
} */
.text-error{
	font-size: 0.8rem;
}

.employee-status-aprroved{
    color: #85AA75!important;
}
.employee-status-pending{
    color: #DFB002!important;
}
.font-weight-normal{
	font-weight: 400;
}
.employee-text-left{
	text-align: left;
}
.text-left{
	text-align: left;
}
.pointer{
	cursor: pointer;
}


/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVtcGxveWVlLWxpc3QuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtDQUNDLFdBQVc7QUFDWjtBQUNBO0NBQ0Msb0JBQW9CO0FBQ3JCO0FBQ0E7Q0FDQyxjQUFjO0NBQ2QsaUJBQWlCO0FBQ2xCO0FBQ0E7Q0FDQyxpQkFBaUI7QUFDbEI7QUFDQTs7R0FFRztBQUNIO0NBQ0MsaUJBQWlCO0FBQ2xCOztBQUVBO0lBQ0ksd0JBQXdCO0FBQzVCO0FBQ0E7SUFDSSx3QkFBd0I7QUFDNUI7QUFDQTtDQUNDLGdCQUFnQjtBQUNqQjtBQUNBO0NBQ0MsZ0JBQWdCO0FBQ2pCO0FBQ0E7Q0FDQyxnQkFBZ0I7QUFDakI7QUFDQTtDQUNDLGVBQWU7QUFDaEIiLCJmaWxlIjoiZW1wbG95ZWUtbGlzdC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLndpZHRoLWF1dG97XHJcblx0d2lkdGg6IGF1dG87XHJcbn1cclxuLmRhdGFUYWJsZXNfaW5mb3tcclxuXHRwYWRkaW5nLXRvcDogMC44NXJlbTtcclxufVxyXG4udGV4dC1lcnJvcntcclxuXHRjb2xvcjogI2RjMzU0NTtcclxuXHRmb250LXNpemU6IDAuOHJlbTtcclxufVxyXG4uZXJyb3ItZnVsbG5hbWV7XHJcblx0bWFyZ2luLXRvcDogLTEwcHg7XHJcbn1cclxuLyogI2NhbmRpZGF0ZUxpc3QgdHIub2RkIHRkLmRhdGFUYWJsZXNfZW1wdHl7XHJcblx0ZGlzcGxheTogbm9uZSFpbXBvcnRhbnQ7XHJcbn0gKi9cclxuLnRleHQtZXJyb3J7XHJcblx0Zm9udC1zaXplOiAwLjhyZW07XHJcbn1cclxuXHJcbi5lbXBsb3llZS1zdGF0dXMtYXBycm92ZWR7XHJcbiAgICBjb2xvcjogIzg1QUE3NSFpbXBvcnRhbnQ7XHJcbn1cclxuLmVtcGxveWVlLXN0YXR1cy1wZW5kaW5ne1xyXG4gICAgY29sb3I6ICNERkIwMDIhaW1wb3J0YW50O1xyXG59XHJcbi5mb250LXdlaWdodC1ub3JtYWx7XHJcblx0Zm9udC13ZWlnaHQ6IDQwMDtcclxufVxyXG4uZW1wbG95ZWUtdGV4dC1sZWZ0e1xyXG5cdHRleHQtYWxpZ246IGxlZnQ7XHJcbn1cclxuLnRleHQtbGVmdHtcclxuXHR0ZXh0LWFsaWduOiBsZWZ0O1xyXG59XHJcbi5wb2ludGVye1xyXG5cdGN1cnNvcjogcG9pbnRlcjtcclxufVxyXG5cclxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/employees/employee-list/employee-list.component.css"],"names":[],"mappings":"AAAA;CACC,WAAW;AACZ;AACA;CACC,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;;GAEG;AACH;CACC,iBAAiB;AAClB;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;AAChB;;;AAGA,g9CAAg9C","sourcesContent":[".width-auto{\r\n\twidth: auto;\r\n}\r\n.dataTables_info{\r\n\tpadding-top: 0.85rem;\r\n}\r\n.text-error{\r\n\tcolor: #dc3545;\r\n\tfont-size: 0.8rem;\r\n}\r\n.error-fullname{\r\n\tmargin-top: -10px;\r\n}\r\n/* #candidateList tr.odd td.dataTables_empty{\r\n\tdisplay: none!important;\r\n} */\r\n.text-error{\r\n\tfont-size: 0.8rem;\r\n}\r\n\r\n.employee-status-aprroved{\r\n    color: #85AA75!important;\r\n}\r\n.employee-status-pending{\r\n    color: #DFB002!important;\r\n}\r\n.font-weight-normal{\r\n\tfont-weight: 400;\r\n}\r\n.employee-text-left{\r\n\ttext-align: left;\r\n}\r\n.text-left{\r\n\ttext-align: left;\r\n}\r\n.pointer{\r\n\tcursor: pointer;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
